export default __webpack_public_path__ + "static/media/hand-and-stone.ac9f2bd6.png";